import { Component } from "@angular/core";
import { PopupMarkerComponent } from "../../popup-marker/popup-marker.component";

@Component({
    selector: 'app-contact-popup',
    templateUrl: './contact-popup.component.html',
    styleUrls: ['contact-popup.component.css']
})

export class ContactPopupComponent extends PopupMarkerComponent{
    fullName;
    email;
    phone;

}
